import { GameManager } from "../../GameManager";
import { BoardManager } from "./boardManager/BoardManager";
import { BoardContainer } from "./BoardContainer";
import { GUI } from "./gui/GUI";
import { HUD } from "./hud/HUD";
import { Background } from "../Background";
import { PauseLayer } from "./layers/PauseLayer";
import { GameOverLayer } from "./layers/GameOverLayer";
import { GameVars } from "../../GameVars";
import { BoardManagerPVBot } from "./boardManager/BoardManagerPVBot";
import { BoardManagerPVP } from "./boardManager/BoardManagerPVP";
import { GameConstants } from "../../GameConstants";
import { EmojisLayer } from "./layers/EmojisLayer";
import { MessagesManager } from "./MessagesManager";
import { MessageLayer } from "./layers/MessageLayer";
import { Game } from "../../Game";
import * as Carrom from "carrom-king-engine";
import { BootScene } from "../BootScene";

declare var gamezop: any;
declare var oMetaManager: any;
export class BoardScene extends Phaser.Scene {

    public static currentInstance: BoardScene;
    public static puckIconPosition: {x: number, y: number};

    public boardManager: BoardManager;
    public messagesManager: MessagesManager;
    public gui: GUI;
    public hud: HUD;
    public emojisLayer: EmojisLayer;
    
    private boardContainer: BoardContainer;
    private pauseLayer: PauseLayer;
    private gameOverLayer: GameOverLayer;
    private messageLayer: MessageLayer;
    private background: Background;

    constructor() {

        super("BoardScene");
    }

    public create(): void {
        console.log("BOARD SCENE");
        gamezop.setState({
          state: "playing",
          score: 0,
          metadata: oMetaManager.meta
        });

        GameManager.setCurrentScene(this);

        BoardScene.currentInstance = this;

        if (GameVars.playingAgainstBot) {
            this.boardManager = new BoardManagerPVBot();
        } else {
            this.boardManager = new BoardManagerPVP();
        }

        this.messagesManager = new MessagesManager();

        this.anims.create({ 
            key: "arrow", 
            frames: this.anims.generateFrameNames( "texture_atlas_1", {prefix: "arrowVFX_", start: 1, end: 16, zeroPad: 2, suffix: ""}), 
            frameRate: 24, 
            repeat: -1
        });

        this.anims.create({ 
            key: "rain", 
            frames: this.anims.generateFrameNames( "texture_atlas_1", {prefix: "rain_loser_", start: 1, end: 7, zeroPad: 2, suffix: ""}), 
            frameRate: 20, 
            repeat: -1
        });

        this.background = new Background(this, 2);
        this.add.existing(this.background);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        this.pauseLayer = null;
        this.gameOverLayer = null;
        this.emojisLayer = null;

        let x: number;
        let y: number;

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            if (GameVars.aspectRatio < 1.4) {
                x = this.hud.playerAvatarContainer.x / BoardContainer.currentInstance.scaleY;
                y = (-GameConstants.GAME_HEIGHT / 2 +  this.hud.playerAvatarContainer.y +  this.hud.playerAvatarContainer.puckIcon.y) / BoardContainer.currentInstance.scaleY;
            } else {
                x = this.hud.playerAvatarContainer.x;
                y = -GameConstants.GAME_HEIGHT / 2 / BoardContainer.currentInstance.scaleY + this.hud.playerAvatarContainer.y +  this.hud.playerAvatarContainer.puckIcon.y;
            }
    
        } else {

            if (GameVars.aspectRatio < 1.4) {
                x = (this.hud.playerAvatarContainer.x + this.hud.playerAvatarContainer.scoreLabel.x) / BoardContainer.currentInstance.scaleY;
                y = (-GameConstants.GAME_HEIGHT / 2 +  this.hud.playerAvatarContainer.y +  this.hud.playerAvatarContainer.scoreLabel.y) / BoardContainer.currentInstance.scaleY;
            } else {
                x = this.hud.playerAvatarContainer.x + this.hud.playerAvatarContainer.scoreLabel.x;
                y = -GameConstants.GAME_HEIGHT / 2 / BoardContainer.currentInstance.scaleY + this.hud.playerAvatarContainer.y +  this.hud.playerAvatarContainer.scoreLabel.y;
            }
        }

        BoardScene.puckIconPosition = {x: x, y: y};

        if (!GameConstants.DEVELOPMENT) {
            this.cameras.main.fadeIn(350, 30, 79, 163);
        }

        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", function(): void {
                Game.currentInstance.launchIntoFullscreen(document.documentElement);
            }, this);
        }
    }

    public update(): void {

        this.boardManager.update();

        this.boardContainer.update();
        this.gui.update();
    }

    public setPucksPositions(): void {

        this.boardContainer.setPucksPositions();
    }

    public onQueenRestituted(queenPosition: Carrom.Vector2D): void {

        this.hud.onQueenRestituted();
        this.boardContainer.onQueenRestituted(queenPosition);
    }

    public onDiskRestituted(disk: any, updateBoard: boolean): void {

        this.hud.onDiskRestituted(disk.color);

        if (updateBoard) {
            this.boardContainer.onDiskRestituted(disk);
        }
    }

    public updateTimer(): void {

        this.hud.updateTimer();
    }

    public onDiskPocketed(disk: Carrom.Disk): void {
        
        this.boardContainer.onDiskPocketed(disk);
    }

    public onPuckActorArrivedtoHUD(color: string, isPlayer: boolean): void {

        this.hud.onPuckActorArrived(color, isPlayer);
    }

    public onGameOver(timeout: boolean): void {

        this.hud.onGameOver();
        this.gui.onGameOver();

        this.background.addStarTiles();
        
        this.gameOverLayer = new GameOverLayer(this, timeout);
        this.add.existing(this.gameOverLayer);
    }

    public showMenu(): void {

        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);
    }

    public hideMenu(): void {

        this.pauseLayer.destroy();
    }

    public showEmojisMenu(): void {
        
        this.emojisLayer = new EmojisLayer(this);
        this.add.existing(this.emojisLayer);
    }

    public hideEmojisMenu(): void {
        if (this.emojisLayer) {
          this.emojisLayer.destroy();
          this.emojisLayer = null;
        }
    }

    public showEmoji(i: number, isPlayer: boolean): void {

        this.hud.showEmoji(i, isPlayer);

        this.hideEmojisMenu();
    }

    public onShot(): void {

        this.boardContainer.onShot();

        this.gui.onShot();
        this.hud.onShot();
    }

    public preTimeOut(): void {

        if (GameVars.turnCompleted) {
            this.boardContainer.removePuck();
            this.gui.deactivateAll();
        }
    }

    public onNewTurn(firstTurn?: boolean): void {

        this.boardContainer.onNewTurn(firstTurn);
        this.messagesManager.onNewTurn(firstTurn);

        this.gui.onNewTurn();
        this.hud.onNewTurn();
    }

    public showMessage(messageType: string): void {
        if (this.messageLayer) {
            this.messageLayer.destroy();
        }
        this.messageLayer = new MessageLayer(this, messageType);
        this.add.existing(this.messageLayer);
    }

    public onFullScreen(): void {

        let scaleFactor = 1;

        if (GameVars.aspectRatio < 1.4) {
            scaleFactor = .8;
        } 

        this.boardContainer.setScale(scaleFactor, scaleFactor * GameVars.scaleY);

        this.hud.scaleY = GameVars.scaleY;
    }
}
